const TextFormatter = value => {
    if (typeof value === "string") {
        const val = value.replace(/_/g, " ");
        return val.charAt(0).toUpperCase() + val.slice(1).toLowerCase();
    } else {
        return value;
    }
};

export default TextFormatter;


export const arrayBufferToBlob = (buffer, state, fileName, type) => {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    const file = window.btoa(binary);
    const mimType =
        type === 'pdf'
            ? 'application/pdf'
            : type === 'xlsx'
            ? 'application/xlsx'
            : type === 'pptx'
            ? 'application/pptx'
            : type === 'csv'
            ? 'application/csv'
            : type === 'docx'
            ? 'application/docx'
            : type === 'jpg'
            ? 'application/jpg'
            : type === 'png'
            ? 'application/png'
            : '';
    const url = `data:${mimType};base64,` + file;
    if (state === 'download') {
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    } else {
        const byteCharacters = atob(file);
        const byteArrays = [];
        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
            const slice = byteCharacters.slice(offset, offset + 512),
                byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        const blob = new Blob(byteArrays, { type: 'application/pdf' });
        const objectURL = URL.createObjectURL(blob) + '#toolbar=0&navpanes=0&scrollbar=0';
        return objectURL;
    }
};